import RUF from "../../../util/redux";

export function modelSetLoanPurpose(state, action) {
  return RUF.updateObject(state, {
    model: RUF.updateObject(state.model, {
      loanPurpose: action.payload
    })
  });
}
